import { IUpdateServicoProdutoUseCase } from "../../../presentation/useCases/update/update_servico_produto_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * UpdateServicoProdutoUseCase
 */

export class UpdateServicoProdutoUseCase implements IUpdateServicoProdutoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async updateServicoProduto(
    idProdutoServico: number,
    ativo: boolean,
    produtoServico: string,
    tipo: number,
    unidade: string | undefined,
    norma: string | undefined,
  ): Promise<void> {
    await this.repository.updateServicoProduto(
      idProdutoServico,
      ativo,
      produtoServico,
      tipo,
      unidade ?? null,
      norma ?? null,
    );
  }
}
